module.exports = __webpack_public_path__ + "static/comp_diagnostics-a19757664371b46f6db688b0efa39a00.webp";